<template>
  <li>
    <router-link :to="{ name: 'payments.show', params: { id: payment.id } }">
			<div class="row">
				<div class="col-sm-6">
					<h2 class="truncate"><strong>Payment #{{ decorated.xero_number }}</strong> &ndash; {{ decorated.carrier_name }}</h2>
				</div>
				<div class="col-sm-6">
					<p class="text-upper" :class="statusClass">{{ decorated.status }}</p>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-push-9 col-sm-3">
					<p>{{ decorated.total_with_gst }}</p>
				</div>
				<div class="col-sm-pull-3 col-sm-9">
					<ul class="details">
						<li><span>Created:</span> {{ decorated.created_date }}</li>
						<li><span>Paid On:</span> {{ decorated.paid_date }}</li>
					</ul>
				</div>
			</div>
		</router-link>
	</li>
</template>

<script>
  import { PaymentDecorator } from 'decorators'

  export default {
    props: ['payment'],

    computed: {
      /**
       * Decorated payment.
       *
       * @return object
       */
      decorated () {
        return new PaymentDecorator(this.payment)
      },

      /**
       * Status class.
       *
       * @return string
       */
      statusClass () {
        if (this.payment.status === 'invoice') {
          return 'text-warning'
        } else if (this.payment.status === 'uploaded') {
          return 'text-primary'
        } else {
          return 'text-success'
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// PaymentItem.vue?7d7f02b1